const OCCURRENCE_TYPES = Object.freeze({
  RECURRING: 'recurring',
  ONE_OFF: 'oneoff',
});

const USAGE_TYPE = Object.freeze({
  DATA: 'data',
  SMS: 'sms',
  CALLS: 'calls',
});

export { OCCURRENCE_TYPES, USAGE_TYPE };
